export enum ToggleType {
    NoMessage = 0,
    Success = 1,
    Errors = 2,
    Warnings = 3
}